import React, {FC, useEffect, useState} from 'react'
import { useIntl } from 'react-intl'
import SharedData from '../../../common/SharedData'
import { getDeliveryDurations } from '../../core/_requests'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'

interface IProps {
     field: { value: any; edit: boolean; changed: boolean; label?: string }
     setFields: any
     saveField: (fieldName: string, params?: any) => Promise<boolean>
}

const MyProfileDeliveryDurationField: FC<IProps> = ({field, setFields, saveField}) => {
  const {formatMessage} = useIntl()
  const {currentUser, language} = SharedData()
  const [options, setOptions] = useState<Array<{delivery_duration_id:number; name:string}>>([])
  const [selectedId, setSelectedId] = useState<string>('')

  useEffect(() => {
    (async () => {
      const {data} = await getDeliveryDurations(currentUser?.token, language)
      setOptions(data.durations || [])
    })()
  }, [])

  useEffect(() => {
    if (!field.edit && !field.value && field.label && options.length) {
      const match = options.find(o => o.name === field.label)
      if (match) setSelectedId(String(match.delivery_duration_id))
    }
  }, [field.edit, field.value, field.label, options])

  const editField = () => {
    setFields((prev: any) => ({
      ...prev,
      delivery_duration: {...prev['delivery_duration'], edit: !prev['delivery_duration'].edit},
    }))
  }

    const onChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const id = e.target.value
        const prev = field.value
        const name =
          options.find(o => String(o.delivery_duration_id) === id)?.name || field.label
        setSelectedId(id)
        setFields((s: any) => ({
          ...s,
          delivery_duration: {...s.delivery_duration, value: id, label: name},
        }))
        try {
          await saveField('delivery_duration', { oldValue: prev, newValue: id })
          editField()
        } catch {
          setFields((s: any) => ({
            ...s,
            delivery_duration: {...s.delivery_duration, value: prev, label: field.label},
          }))
          setSelectedId(prev || '')
        }
      }

  const displayName =
    options.find(o => String(o.delivery_duration_id) === (field.value || selectedId))?.name || field.label || ''

  return (
    <div className='row'>
      <div className='col-md-6'>
        <label className='text-gray-600 fw-bold fs-5'>{formatMessage({ id: "delivery_duration" })}:</label>
      </div>
      <div className='col-md-6 d-flex'>
        {!field.edit ? (
          <div className='d-flex gap-1 flex-wrap'>
            <p className='text-dark fs-4 mb-0'>{displayName}</p>
            <div className='cursor-pointer w-25px' onClick={editField}>
              <img alt='edit' width='15' src={toAbsoluteUrl('/media/logos/pen-solid.svg')} />
            </div>
            {field.changed && <p className='mb-0 text-success fw-bold'>{formatMessage({ id: "your_change_saved" })}</p>}
          </div>
        ) : (
          <select
            className='form-control border-gray-900 text-gray-900'
            id='delivery_duration'
            value={field.value || selectedId}
            onChange={onChange}
          >
            <option value="">{formatMessage({ id: "please_select" })}</option>
            {options.map(o => (
              <option key={o.delivery_duration_id} value={String(o.delivery_duration_id)}>{o.name}</option>
            ))}
          </select>
        )}
      </div>
    </div>
  )
}

export default MyProfileDeliveryDurationField
